import { getInternalUsers, INTERNAL_USERS_MAX_LIMIT } from './GetInternalUsers';

/**
 * The page size the role lists ask for. These feed dropdowns, which have no
 * pagination to fall back on, so they request the server's maximum: 100 is a
 * hard cap — auth-service clamps anything larger — and a role with more than
 * 100 holders truncates silently.
 */
export const INTERNAL_USERS_PAGE_LIMIT = INTERNAL_USERS_MAX_LIMIT;

/**
 * Role slugs this app queries as a single-role list. Recruiter and AE carry
 * identical claims and differ only for list purposes, so the slug is the whole
 * distinction. The full role set lives in `domain/Users/internalRoles`, which
 * is the display layer for the GoTu Admin page; this is the short list of roles
 * that specifically back a dropdown.
 */
export const InternalUserRoles = {
  DsoManager: 'dso',
  Recruiter: 'recruiter',
};

/**
 * Fetches the holders of one internal role from auth-service.
 *
 * The shared replacement for the hand-edited Remote Config lists: a role query
 * maintains itself as staff join and leave. Both the DSO manager list and the
 * recruiter list come through here.
 *
 * A thin wrapper over `getInternalUsers` — the request it makes is unchanged
 * from when this owned it, which the params assertion in
 * GetInternalUsersByRole.test.js pins. `sortBy: 'first_name'` (the shared
 * default) reproduces the monolith's `.sort({ first_name: 1 })`, so the
 * dropdown order does not change from the lists this replaced.
 *
 * @param {string} role - Role slug, e.g. 'dso' or 'recruiter'
 * @returns {Promise<import('../types/User.api').IGetInternalUsersApiResponse>}
 */
export const getInternalUsersByRole = async (role) =>
  getInternalUsers({ roles: [role], limit: INTERNAL_USERS_PAGE_LIMIT });
